<template>
    <span>{{ security_type[value] }}</span>
  </template>
  <script>
  export default {
    props: ['value'],
    data() {
      return {
        'security_type': ['', 'Cash', 'CFD', 'Options', 'Futures', 'Bonds', 'FX', 'FX Options', 'Structured Notes']
      }
    }
  }
  </script>
  